export class DocumentTypeModel {
    constructor(
      public documentTypeId: string,
      public documentTypeName: string,
      public documentTypeDesc: string,
      public commentDueDays: number,
      public hideReviewRequest: boolean,
      public intake: boolean,
      public publishDefault: boolean,
      public publishReadOnly: boolean,
      public commentsDueDate: string,
      public actionDue: string) {}
  }
